import React, { useState, useCallback, useEffect } from "react";
import Search from "../../../molecules/search";
import CustomButton from "../../../atoms/CustomButton";
import { useCookies } from "react-cookie";
import { getData, patchData } from "../../../../services";
import VerticalMenu from "../../../icons/VerticalMenu";
import CustomMenu from "../../../atoms/CustomMenu";
import Edit from "../../../icons/Edit";
import Delete from "../../../icons/Delete";
import DeleteModal from "../../../organisms/modals/DeleteModal";
import { deleteData } from "../../../../services";
import SideOverlay from "../../../atoms/SideOverlay";
import { v4 as uuidv4 } from "uuid";
import Form from "./Form";
import {
  getdepartmentList,
  getEmployeeList,
  getRolesList,
  getClientList,
  getBusinessSegmentList,
  getTeamsList,
  getAllProjects,
} from "../../../../services/basicGets";
import toast from "react-hot-toast";
import {
  errorStyles,
  confimationStyles,
} from "../../../../assets/styles/toast";
import ViewDetails from "../activities/view";
import Pagination from "../../../molecules/Pagination";
import StatusBackground from "../../../atoms/StatusBackground";
import ColorDots from "../../../atoms/ColorDots";
import NoContentCard from "../../../atoms/NoContentCard";
import NoContentIcon from "../../../icons/NocontentIcon";
import { Select, MenuItem, Tooltip } from "@mui/material";
import { ProjectStatus, Priorities } from "../../../../helpers/staticData";
import {
  downloadReport,
  handleClickDownload,
} from "../../../../services/downloadService";
import { Loader, Upload } from "lucide-react";
import CommonFilter from "../../../atoms/CommonFilter";
import TaskCustomDataGrid from "../../../organisms/CustomDatagrid/EditableTable";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment/moment";

const Projects = ({ disabled = false }) => {
  const priorityOptions = ["Low", "Medium", "High", "Critical"];

  //access details handling
  const accessData = useSelector((state) => state.accessDetails?.accessData);
  const projectAccess =
    accessData?.access?.find((module) => module.module === "Projects") || {};
  const isAdmin = accessData?.role?.label === "Admin";

  const canCreate = isAdmin || projectAccess?.is_create;
  const canEdit = isAdmin || projectAccess?.is_edit;
  const canDelete = isAdmin || projectAccess?.is_delete;
  const canExport = isAdmin || projectAccess?.is_export;

  const statusOptions = ["Ongoing", "Closed"];
  const [filters, setFilters] = useState({});
  const [cookies] = useCookies(["e_t"]);
  const [selectedRow, setSelectedRow] = useState();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(25);
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchedValue, setSearchedValue] = useState();
  const [roles, setRoles] = useState([]);
  const [Teams, setTeams] = useState([]);
  const [Client, setClient] = useState([]);
  const [BusinessSegment, setBusinessSegment] = useState([]);
  const [Employee, setEmployee] = useState(null);
  const [employees, setEmployees] = useState([]);
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [Projects, setProjects] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    modalData: null,
    isDeleteModalOpen: false,
    isViewModalOpen: false,
    modalId: "",
    name: "",
  });
  const [isExporting, setIsExporting] = useState(false);

  const navigate = useNavigate();

  const filterOptions = [
    {
      id: "status",
      label: "Status",
      type: "multi-select",
      options: ProjectStatus,
    },
    {
      id: "priority",
      label: "Priority",
      type: "multi-select",
      options: Priorities,
    },
    {
      id: "teams",
      label: "Teams",
      type: "multi-select",
      options: Teams,
    },
    {
      id: "assignee",
      label: "Assignee",
      type: "multi-select",
      options: employees,
    },
    {
      id: "business_segment",
      label: "Business Segment",
      type: "multi-select",
      options: BusinessSegment,
      customStyles: { minWidth: "165px" },
    },
  ];

  const getProjectsData = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await getData({
        endpoint: "Project/getAllProjects",
        params: {
          search_query: searchedValue,
          page: currentPage,
          limit: itemsPerPage,
          priority: JSON.stringify(filters?.priority),
          status: JSON.stringify(filters?.status),
          assigned_employees: JSON.stringify(filters?.assignee),
          projects_ids: JSON.stringify(filters?.project),
          employee_id: isAdmin ? null : cookies.euid,
          assigned_teams: JSON.stringify(filters?.teams),
          businessSegments: JSON.stringify(filters?.business_segment),
          // business_id: cookies.bid,
        },

        token: cookies.e_t,
      });
      if (res) {
        setTableData(res?.data);
      }
    } catch (error) {
      console.error(error); // Use console.error for errors
    } finally {
      setIsLoading(false);
    }
  }, [cookies.e_t, currentPage, itemsPerPage, searchedValue, filters, isAdmin]);

  useEffect(() => {
    if (accessData) {
      getProjectsData();
    }
  }, [getProjectsData, accessData]);

  useEffect(() => {
    (async () => {
      const resRoles = await getRolesList({
        token: cookies.e_t,
      });
      const empRoles = await getEmployeeList({
        params: { ...(!isAdmin && { employee_id: cookies.euid }) },
        token: cookies.e_t,
      });
      const clientRoles = await getClientList({
        token: cookies.e_t,
      });
      const BusinessSegmentRoles = await getBusinessSegmentList({
        token: cookies.e_t,
      });
      const teamRoles = await getTeamsList({
        ...(!isAdmin && { params: { employee_id: cookies.euid } }),
        token: cookies.e_t,
      });

      const teamProjects = await getAllProjects({
        token: cookies.e_t,
      });

      setBusinessSegment(BusinessSegmentRoles?.data);
      setTeams(teamRoles?.data?.teams);
      setClient(clientRoles);
      setProjects(teamProjects?.data);
      setEmployees(empRoles?.employeeResponseValueLabel);
      setEmployee(empRoles);
      setRoles(resRoles);
    })();
  }, []);

  //   Menu

  const getTeamList = async () => {
    const teams = await getTeamsList({
      token: cookies.e_t,
    });

    setTeams(teams?.data?.teams);
  };

  const getClientLists = async () => {
    const clients = await getClientList({
      token: cookies.e_t,
    });

    setClient(clients);
  };

  const handleStatusMenu = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const menu = [
    canEdit && {
      icon: <Edit height="20" width="20" />,
      label: "Edit",
      onClick: () => {
        setAnchorEl(null);
        handleEdit(selectedRow);
      },
    },
    canDelete && {
      icon: <Delete />,
      label: "Delete",
      onClick: () => {
        setAnchorEl(null);
        handleDeleteModal(selectedRow);
      },
    },
  ].filter(Boolean); // Removes undefined values if conditions are false

  const handleEdit = (tableData) => {
    setModalState((prevState) => ({
      ...prevState,
      modalId: tableData.id,
      modalData: tableData,
      isModalOpen: true,
      title: "Edit Project",
    }));
  };

  const handleView = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isViewModalOpen: true,
      modalId: data.invite_id,
      data: data,
      name: data?.visitor_name,
    }));
  };

  const handleDownload = async () => {
    try {
      setIsExporting(true);
      const res = await getData({
        endpoint: "Project/exportProject",
        token: cookies.e_t,
        params: {
          priority: filters?.priority?.length
            ? JSON.stringify(filters.priority)
            : null,
          status: filters?.status?.length
            ? JSON.stringify(filters.status)
            : null,
          assigned_employees: filters?.assignee?.length
            ? JSON.stringify(filters.assignee)
            : null,
          assigned_teams: filters?.teams?.length
            ? JSON.stringify(filters.teams)
            : null,
          employee_id: isAdmin ? null : cookies.euid,
          businessSegments: JSON.stringify(filters.business_segment),
        },
        // fileName: "BusinessReport",
      });

      if (res) {
        // Call the handleClickDownload function with the URL and desired file name
        await handleClickDownload(res, "ProjectReport");

        toast.success("Projects Exported Successfully", {
          style: confimationStyles,
          duration: 1000,
        });
      } else {
        toast.error("An Error Occured Please Try Again Later.", {
          duration: 1000,
          style: errorStyles,
        });
      }
    } catch (error) {
      toast.error("An Error Occured.", { style: errorStyles, duration: 1000 });
    } finally {
      setIsExporting(false);
    }
  };

  const updateTaskField = async (projectId, field, value, token) => {
    try {
      const response = await patchData({
        endpoint: `Project/updateProjectEntity`,
        params: { project_id: projectId },
        data: { [field]: value },
        token: token,
      });
      return response;
    } catch (error) {
      toast.error("An Error Occured Please Try Again Later.", {
        duration: 1000,
        style: errorStyles,
      });
    }
  };

  const columns = [
    {
      field: "name",
      headerName: "Name",
      flex: 0.7,
      minWidth: 150,
      sortable: true,
      cellClassName: "cursor-pointer",
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <span className="multiline-ellipsis">{params.value}</span>
        </Tooltip>
      ),
    },
    // {
    //   field: "client_name",
    //   headerName: "Client",
    //   minWidth: 150,
    //   flex: 0.7,
    // },
    {
      field: "priority",
      headerName: "Priority",
      minWidth: 150,
      flex: 0.5,
      sortable: true,
      renderCell: (params) => {
        return <ColorDots priority={params.value} />;
      },
      cellClassName: "cursor-pointer",
      editable: true, // Enable editing
      renderEditCell: (params) => (
        <Select
          value={params.value}
          onChange={async (e) => {
            const newValue = e.target.value;
            const originalValue = params.value;

            // Optimistic update
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newValue,
            });

            const row = params.api.getRow(params.id);
            await updateTaskField(row.id, "priority", newValue, cookies.e_t);
          }}
          fullWidth
          className="editable-select"
        >
          {priorityOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
    },
    {
      field: "owners_info",
      headerName: "Project owner",
      minWidth: 200,
      flex: 0.8,
      renderCell: (params) => {
        const owners = params?.row?.owners_info || [];

        const ownerNames = owners
          .filter((owner) => owner.owner_name?.trim())
          .reduce((acc, owner) => {
            if (!acc.some((o) => o.owner_id === owner.owner_id)) {
              acc.push(owner);
            }
            return acc;
          }, [])
          .map((owner) => owner.owner_name);

        const displayText =
          ownerNames.length > 2
            ? `${ownerNames.slice(0, 2).join(", ")} +${ownerNames.length - 2}`
            : ownerNames.join(", ");

        return (
          <Tooltip title={ownerNames.join(", ")} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "team_info",
      headerName: "Assigned Team",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const team = params?.row?.team_info || [];

        const teamNames = team
          .map((team) => team.team_name)
          .filter((name) => name?.trim());

        const displayText =
          teamNames.length > 2
            ? `${teamNames.slice(0, 2).join(", ")} +${teamNames.length - 2}`
            : teamNames.join(", ");

        return (
          <Tooltip title={teamNames.join(", ")} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "employee_info",
      headerName: "Assigned Members",
      minWidth: 200,
      flex: 1,
      renderCell: (params) => {
        const Members = params.row.employee_info || [];

        const employeeNames = Members.map((emp) => emp.employee_name).filter(
          (name) => name?.trim()
        );

        const displayText =
          employeeNames.length > 2
            ? `${employeeNames.slice(0, 2).join(", ")} +${
                employeeNames.length - 2
              }`
            : employeeNames.join(", ");

        return (
          <Tooltip title={employeeNames.join(", ")} arrow>
            <span
              style={{
                cursor: "pointer",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {displayText}
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Created Date",
      minWidth: 180,
      renderCell: (params) => {
        return (
          <div>
            {params?.row?.created_at &&
              moment(params.row?.created_at).format("DD/MM/YYYY hh:mm a")}
          </div>
        );
      },
      sortable: true,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 0.5,
      sortable: true,
      renderCell: (params) => {
        return <StatusBackground status={params.value} />;
      },
      cellClassName: "cursor-pointer",
      editable: true,
      renderEditCell: (params) => (
        // <Select
        //   value={params.value}
        //   className="editable-select"
        //   onChange={(e) =>
        //     params.api.setEditCellValue({
        //       id: params.id,
        //       field: params.field,
        //       value: e.target.value,
        //     })
        //   }
        //   fullWidth
        // >
        //   {statusOptions.map((option) => (
        //     <MenuItem
        //       key={option}
        //       value={option}
        //       className="editable-select-option"
        //     >
        //       {option}
        //     </MenuItem>
        //   ))}
        // </Select>
        <Select
          value={params.value}
          className="editable-select"
          onChange={async (e) => {
            const newStatus = e.target.value;
            const originalStatus = params.value;

            // Optimistic update
            params.api.setEditCellValue({
              id: params.id,
              field: params.field,
              value: newStatus,
            });

            try {
              const row = params.api.getRow(params.id);
              await updateTaskField(
                row.id,
                "status", // Field name
                newStatus,
                cookies.e_t
              );

              // Optional: Refresh data
              getProjectsData();
            } catch (error) {
              // Revert on error
              params.api.setEditCellValue({
                id: params.id,
                field: params.field,
                value: originalStatus,
              });
              toast.error("Failed to update status", {
                style: errorStyles,
                duration: 1000,
              });
            }
          }}
          fullWidth
        >
          {statusOptions.map((option) => (
            <MenuItem
              key={option}
              value={option}
              className="editable-select-option"
            >
              {option}
            </MenuItem>
          ))}
        </Select>
      ),
    },

    ...(canEdit || canDelete
      ? [
          {
            field: "actions",
            headerName: "",
            flex: 0.2,
            renderCell: (params) => (
              <div className="table-icons-container">
                <div onClick={(event) => handleStatusMenu(event, params.row)}>
                  <VerticalMenu />
                </div>
                <CustomMenu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  items={menu}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  const handlePageChange = useCallback((page) => {
    setCurrentPage(page);
  }, []);

  const handleItemsPerPageChange = useCallback((perPage) => {
    setCurrentPage(1);
    setItemsPerPage(perPage);
  }, []);

  const handleDeleteModal = (data) => {
    setModalState((prevState) => ({
      ...prevState,
      isDeleteModalOpen: true,
      modalId: data.id,
      name: data.name,
    }));
  };

  const handleDeletion = async () => {
    try {
      await deleteData({
        endpoint: "Project/DeleteProject",
        params: {
          project_id: modalState?.modalId,
        },
      });
      toast.success("Project Deleted Sucessfully", {
        style: confimationStyles,
        duration: 1000,
      });
      getProjectsData();
      setModalState((prevState) => ({
        ...prevState,
        isDeleteModalOpen: false,
      }));
    } catch (error) {
      toast.error("An Error Occured While Deleting", {
        style: errorStyles,
        duration: 1000,
      });
    }
  };

  //  Modal Handling  ---------------
  const openModal = (title, data) => {
    const modalId = uuidv4();
    setModalState((prevState) => ({
      ...prevState,
      modalId,
      isModalOpen: true,
      title,
      modalData: data,
    }));
  };

  const closeModal = () => {
    setModalState((prevState) => ({ ...prevState, isModalOpen: false }));
  };

  const CustomNoRowsOverlay = React.memo(() => {
    return (
      <>
        <NoContentCard
          title="No Projects Found"
          type="Project"
          subtitle={
            "You haven’t started any projects yet. Create one to get going!"
          }
        />
      </>
    );
  });

  const handleFilterChange = (newFilters) => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
    setFilters(newFilters);
  };

  return (
    <div id="Project-Management" className="main-container">
      <div className="d-flex justify-content-between">
        <div className="d-flex gap-2 segregation-container">
          <Search
            placeholder="Search"
            onSearchEmit={(item) => {
              if (currentPage !== 1) {
                setCurrentPage(1);
              }
              setSearchedValue(item);
            }}
          />
        </div>
        {(canExport || canCreate) && (
          <div className="d-flex gap-2">
            {canExport && (
              <CustomButton
                text={isExporting ? "Exporting..." : "Export"}
                handleClick={() => handleDownload()}
                icon={
                  isExporting ? (
                    <Loader className="animate-spin" size={16} />
                  ) : (
                    <Upload size={16} />
                  )
                }
                disabled={isExporting || disabled}
                iconRequired
              />
            )}

            {canCreate && (
              <CustomButton
                text="Create Project"
                type="btn-primary"
                handleClick={() => openModal("Create Project")}
              />
            )}
          </div>
        )}
      </div>

      <div className="mt-2">
        <CommonFilter
          filters={filterOptions}
          onFilterChange={handleFilterChange}
        />
      </div>

      <div className="mt-3">
        <TaskCustomDataGrid
          columns={columns}
          CustomNoRowsOverlay={CustomNoRowsOverlay}
          rows={tableData?.projects || []}
          onCellClick={(params, event) => {
            if (!params || typeof params.field !== "string") {
              return;
            }
            if (params.field === "name") {
              navigate(`/dashboard/projects/projectinfo/${params?.row?.id}`, {
                state: { name: params?.row?.name },
              });
            }
          }}
          isLoading={isLoading}
          isLoadingStateProvided={true}
        />
      </div>

      {modalState?.isModalOpen && (
        <SideOverlay
          id={modalState?.modalId}
          title={modalState.title}
          onClose={closeModal}
          isOpen={modalState?.isModalOpen}
          side="right"
          width="550px"
        >
          <Form
            onFormDirty={setIsFormDirty}
            initialData={
              modalState.title === "Edit Project" ? modalState.modalData : null
            }
            employeeList={Employee}
            rolesList={roles}
            BusinessSegmentList={BusinessSegment}
            clientList={Client}
            teamList={Teams}
            isAdmin={isAdmin}
            refetchData={getProjectsData}
            refetchClientList={getClientLists}
            refetchTeamList={getTeamList}
            onClose={() => closeModal("submit")}
          />
        </SideOverlay>
      )}

      {tableData?.total_records > 10 && (
        <Pagination
          itemsPerPage={itemsPerPage}
          totalItems={tableData?.total_records}
          currentPage={currentPage}
          onPageChange={handlePageChange}
          onItemsPerPageChange={handleItemsPerPageChange}
        />
      )}

      {modalState.isViewModalOpen && (
        <SideOverlay
          // name={modalState.name}
          title={modalState?.data?.name}
          id={modalState.modalId}
          isOpen={modalState.isViewModalOpen}
          isLoading={false}
          side="right"
          width="550px"
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isViewModalOpen: false,
            }))
          }
        >
          <ViewDetails data={modalState.data} />
        </SideOverlay>
      )}

      {modalState.isDeleteModalOpen && (
        <DeleteModal
          name={modalState.name}
          id={modalState.modalId}
          isActive={modalState.isDeleteModalOpen}
          onClose={() =>
            setModalState((prevState) => ({
              ...prevState,
              isDeleteModalOpen: false,
            }))
          }
          title="Project"
          onClick={handleDeletion}
        />
      )}
    </div>
  );
};

export default Projects;
